import { useEffect } from 'react'
import { arrayFilterNonNullable } from 'services/array'
import { Nullable } from 'types'

/**
 * Custom hook to preload an array of image URLs
 * @param urls Array of image URLs to preload. Falsy values are ignored.
 */
const usePreloadImage = (url: Nullable<string>) => {
  useEffect(() => {
    if (url) {
      const img = new Image()
      img.src = url
    }
  }, [url])
}

export default usePreloadImage
